const resource = 'uploads'

export default $axios => ({
  download(id, params) {
    return $axios(
      {
        method: 'GET',
        url: `/${resource}/${id}/download`,
        responseType: 'blob',
      },
      { params }
    )
  },

  getServiceName: name => 'uploadService',
})
